/** Delad typ för AI:ns prisbedömning – används både på server och i gränssnittet. */
export type PriceFlag = "low" | "high";

export type PriceAssessment = {
  /** null = priset ser rimligt ut. */
  flag: PriceFlag | null;
  /** Kort förklaring på svenska, visas för säljaren och (kortare) på annonsen. */
  note: string;
  /** AI:ns rimliga intervall i kronor, om den kunde bedöma det. */
  min?: number | null;
  max?: number | null;
};

export function priceFlagTitle(flag: PriceFlag): string {
  return flag === "low" ? "Kontrollera priset – ovanligt lågt" : "Kontrollera priset – ovanligt högt";
}

export function priceFlagShort(flag: PriceFlag): string {
  return flag === "low"
    ? "Priset är ovanligt lågt för den här typen av pryl. Var extra noga innan du betalar."
    : "Priset ligger klart över vad liknande prylar brukar kosta. Jämför gärna innan du köper.";
}

export function formatPriceRange(min?: number | null, max?: number | null): string | null {
  if (!min || !max) return null;
  return `${min.toLocaleString("sv-SE")}–${max.toLocaleString("sv-SE")} kr`;
}

/** Över den här summan vill vi alltid titta på annonsen först. */
export const HIGH_PRICE_HARD_LIMIT = 100000;

/**
 * Avgör om priset är så högt att annonsen inte får gå ut direkt. Då krävs ett
 * godkännande från oss – säljaren får antingen sänka priset eller skicka in en
 * begäran med en kort motivering.
 */
export function needsPriceApproval(
  price: number,
  assessment?: PriceAssessment | null,
): { blocked: boolean; min: number | null; max: number | null } {
  const max = assessment?.max ?? null;
  const min = assessment?.min ?? null;
  const wayOverEstimate = Boolean(assessment?.flag === "high" && max && price > max * 3);
  return { blocked: price > HIGH_PRICE_HARD_LIMIT || wayOverEstimate, min, max };
}

